<div class="head">
        <div class="header">
                <h2>
                {{ mode === 'allAccounts'
                ? 'All Accounts Detail Billing'
                : 'Monthly Detailed Billing' }}
                </h2>                <span class="refresh-time">Page refresh time: ----</span>
        </div>

        <div class="actions">
                <button
                class="btn btn-outline-primary"
                (click)="onDownloadReport()"
                >
                        <i class="fa-solid fa-download"></i> Download all to CSV
                </button>

<button class="btn btn-outline-primary" (click)="exportPDF($event)">
  <i class="fa-solid fa-print"></i> Print
</button>

                <span class="btn btn-primary d-flex align-items-center gap-3 text-white">
                        <span class="text-white"><i class="fa-solid fa-calendar me-2"></i>Billing period:</span>
                        <span class="flex-grow-1">
                                <input autocomplete="off" class="datetimepicker form-control" type="text"
                                        placeholder="Select Month"
                                        style="border: none; box-shadow: none; background: transparent; padding: 0; color:white" />
                        </span>
                </span>

        </div>
</div>


<app-bill-summary [summary]='summary' [monthYear]="monthYear" [account]="account"
        [highestspend]="highestspend" [mode]="mode"></app-bill-summary>

<div class="tabs">
        <button class="tab-button" *ngIf="mode === 'allAccounts'" [class.active]="activeTab === 'account'"
                (click)="switchTab('account')">Charges by
                account</button>
        <button class="tab-button" [class.active]="activeTab === 'service'" (click)="switchTab('service')">Charges by
                service</button>
        <button class="tab-button" [class.active]="activeTab === 'invoices'"
                (click)="switchTab('invoices')">Invoices</button>

        <button class="tab-button" [class.active]="activeTab === 'taxes'" (click)="switchTab('taxes')">Taxes by
                service</button>
</div>
<app-charges-by-service *ngIf="mode !== 'allAccounts' && activeTab === 'service'" [monthYear]="monthYear" [accountId]="accountId"
        [regionId]="regionId"></app-charges-by-service>
<app-all-charges-by-service
  *ngIf="mode === 'allAccounts' && activeTab === 'service'"
  [monthYear]="monthYear"
  [accountId]="accountId"
  [regionId]="regionId"
  (initialized)="onAllChargesReady()"
></app-all-charges-by-service>
<app-charges-by-account *ngIf=" activeTab==='account'" [monthYear]="monthYear" [accountId]="accountId"
        [regionId]="regionId"></app-charges-by-account>
<app-invoices *ngIf="activeTab === 'invoices'"></app-invoices>
<app-tax-by-service *ngIf="activeTab === 'taxes'"></app-tax-by-service>